import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Header from "../stories/components/Header.js";

export default function ToneOfVoice() {
  return (
    <Container className="mb-6">
      <article>
        <Header
          title="Språk"
          lead="Statsforvalteren skal bruke et klart og lettfattelig språk. Vi
        skal være et godt forbilde for språkbruk i det offentlige."
        />
        <main>
          <Row className="content">
            <Col md={{ span: 8, offset: 2 }}>
              <p>
                Det er et mål at alt vi skriver skal bli forstått på første
                forsøk. Klarspråk fremmer demokrati og rettssikkerhet, og det
                sparer oss for merarbeidet med å forklare hva vi <i>egentlig</i>{" "}
                mener.
              </p>
              <p>
                Å uttrykke seg klart betyr ikke å forenkle språket for enhver
                pris. Forenkling skal ikke føre til et fattig og unyansert
                språk.
              </p>
              <p>
                Ikke alle tekster kan være enkle, og ikke alle tekster kan være
                frie for fagspråk. Med klarspråk mener vi korrekt, klart og
                brukertilpasset språk. En tekst er skrevet i klarspråk dersom
                leserne:
              </p>
              <ul>
                <li>finner det de trenger. </li>
                <li>forstår det de finner. </li>
                <li>kan bruke det de finner til å gjøre det de skal. </li>
              </ul>
              <p>
                Les mer på <a href="https://www.sprakradet.no/klarsprak/">klarspråk.no</a>
              </p>
            </Col>
          </Row>
        </main>
      </article>
    </Container>
  );
}

